import { CoreLink } from '@uncinc/react-drupal-core';
import React from 'react';
import classnames from 'classnames';

import './style.scss';

const ContactPerson = ({ title, role, className, email, phoneNumber }) => (

  <div className={classnames(className, 'ContactPerson')}>
    <span className="ContactPerson__Function">{ role }</span>
    <h4 className="ContactPerson__title">{ title }</h4>
    <div className="ContactPerson__links">
      <span className="ContactPerson__links__link">
        <CoreLink to={`mailto:${email}`}>
          <i className="icon icon-after icon-mail" /><span>E-mail</span><i className="icon icon-after icon-chevron-right" />
        </CoreLink>
      </span>
      <span className="ContactPerson__links__link">
        <CoreLink to={`tel:${phoneNumber}`}>
          <i className="icon icon-after icon-phone" /><span>{phoneNumber}</span><i className="icon icon-after icon-chevron-right" />
        </CoreLink>
      </span>
    </div>
  </div>
);

export default ContactPerson;
